import React from "react"
import { Box } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"
import ReportFormHeader from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Header"
import ReportFormDrawerFooter from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Footer"
import { isReportDrawerOpen } from "Pages/ReportsAlerts/Reports/@signals"
import { dsColorNew } from "@palette"


// The report form: a full-width page over the list with its header and footer always in view
// and the sections as cards in one centred column
export default function ReportFormDrawer({ children }) {
	return <DrawerSeeker
		title={<ReportFormHeader/>}
		isOpen={isReportDrawerOpen.value}
		anchor="right"
		width="100%"
		variant="persistent"
		customFooter={<ReportFormDrawerFooter/>}
		titleProps={{ sx: { p: 0, borderBottom: `1px solid ${dsColorNew.grayBorder}`, backgroundColor: dsColorNew.white } }}
		contentProps={{ dividers: false, sx: { backgroundColor: dsColorNew.contentBg, px: 3, py: 2.5, '.MuiDialogTitle-root + &': { pt: 2.5 } } }}
		actionProps={{ sx: { px: 3, py: 1.5, gap: 1, borderTop: `1px solid ${dsColorNew.grayBorder}`, backgroundColor: dsColorNew.white } }}
	>
		<Box sx={{ maxWidth: 1080, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
			{children}
		</Box>
	</DrawerSeeker>
}
